import Vue from "vue";
import VueRouter from "vue-router";
import Main from "./views/layouts/main.vue";
import Courses from "./views/landig/getAllCourses.vue";
import Contact from "./views/landig/contact.vue";
import obstaculos  from "./views/landig/10-obstaculos/10-obstaculos.vue";
import thanks from "./views/landig/10-obstaculos/thanks.vue";
import TelemedicinaDiabetes from "./views/landig/telemedicina-diabetes/telemedicina-diabetes.vue";
import DiabetesThanks from "./views/landig/telemedicina-diabetes/thanks.vue";
import store from "./views/landig/store.vue";
import ComunicacionesTM from "./views/landig/leads_management/venta_comunicacion_tm.vue";
import TelesaludClick from "./views/landig/leads_management/venta_telesalud_click.vue";
import ObstaculosTM from "./views/landig/leads_management/obstaculos-tm.vue";
import AuthStore from "./views/auth/store.vue";
import Login from "./views/auth/login.vue";
import Register from "./views/auth/register.vue";
import ResetPass from "./views/auth/resetPassword.vue";
import ResetPassConfirm from "./views/auth/resetPasswordConfirm.vue";
import DashStore from "./views/pages/store.vue";
import CourseDescription from "./views/pages/courses/course_description.vue";
import CourseIn from "./views/pages/courses/CourseIn.vue";
import myCourses from "./views/pages/courses/my_courses.vue";
import Settings from "./views/pages/settings/general_setting.vue";
import PaymentIni from "./views/pages/payment/payment_ini.vue";
import PaymentSuccess from "./views/pages/payment/payment_success.vue";
import PaymentFailure from "./views/pages/payment/payment_failure.vue";
import PaymentPending from "./views/pages/payment/payment_pending.vue";
import ExternalCheckout from "./views/pages/payment/external_checkout.vue";
import Category from "./views/pages/Category.vue";
import Detail from "./views/pages/Detail/Detail.vue";
import LandingTelemedicinaCongratz from "./views/landig/landing_telemedicina/Congratz.vue";
import routes from "../v2/src/router/routes";
import diabetesTelemedicine from "./views/landig/diabetesTelemedicine/Index.vue";
import diabetesTelemedicineThanks from "./views/landig/diabetesTelemedicine/thanks.vue";
import landingMap from "./views/landig/landing-map.vue";

Vue.use(VueRouter);

const routesv1 = [
  {
    path: "*",
    redirect: "/",
    beforeEnter: (to, from, next) => {
      if (localStorage.getItem("user")) 
        next(`/v2/home`);
      else {
        localStorage.clear();
        next();
      }
    },
  },
  {
    path: "/bases-telemedicina/gracias",
    name: "TelemedicinaCongratz",
    component: LandingTelemedicinaCongratz,
    beforeEnter: (to, from, next) => {
      if (localStorage.getItem("user")) 
        next(`/v2/home`);
      else {
        localStorage.clear();
        next();
      }
    },
  },
  {
    path: "/telemedicina-diabetes",
    name: "diabetesTelemedicine",
    component: diabetesTelemedicine,
  },
  {
    path: "/telemedicina-diabetes/gracias",
    name: "diabetesTelemedicineThanks",
    component: diabetesTelemedicineThanks,
  },
  {
    path: "/",
    component: store,
    children: [
      {
        path: "/",
        name: "Home",
        component: Main,
      },

      {
        path: "/category/:slug?",
        name: "Category",
        component: Category,
      },

      {
        path: "/detail/:slug",
        name: "Detail",
        component: Detail,
      },
      {
        path: "/courses",
        name: "Courses",
        component: Courses,
      },
      {
        path:"/landing-map",
        name: "landingMap",
        component: landingMap,
      },
      {
        path:"/landing/10-obstaculos",
        name: "10-obstaculos",
        component: obstaculos,
      },
      {
        path: "/landing/thanks",
        name: "thanks",
        component: thanks,
      },
      {
        path: "/landing/telemedicina-diabetes",
        name: "telemedicina-diabetes",
        component: TelemedicinaDiabetes,
      },
      {
        path: "/landing/telemedicina-diabetes/thanks",
        name: "DiabetesThanks",
        component: DiabetesThanks,
      },

      {
        path: "/contact",
        name: "Contact",
        component: Contact,
      },

      {
        path: "/pro/telemedicina",
        name: "TelesaludClick",
        component: TelesaludClick,
      },
      {
        path: "/pro/comunicacion-tm",
        name: "ComunicacionesTM",
        component: ComunicacionesTM,
      },

      {
        path: "/pro/obstaculos-tm",
        name: "ObstaculosTM",
        component: ObstaculosTM,
      },

      {
        path: "/checkout/:price/:token",
        name: "ExternalCheckout",
        component: ExternalCheckout,
      },
    ],
    beforeEnter: (to, from, next) => {
      if (localStorage.getItem("user")) 
        next(`/v2/home`);
      else {
        localStorage.clear();
        next();
      }
    },
  },

  {
    path: "/auth",
    component: AuthStore,
    children: [
      {
        path: "/auth/login",
        name: "Login",
        component: Login,
      },
      {
        path: "/login",
        redirect: "/auth/login",
      },
      {
        path: "/auth/register",
        name: "Register",
        component: Register,
      },
      {
        path: "/auth/reset-password",
        name: "ResetPass",
        component: ResetPass,
      },

      {
        path: "/reset-password/:email/:token",
        name: "ResetPassConfirm",
        component: ResetPassConfirm,
      },
    ],
    beforeEnter: (to, from, next) => {
      if (localStorage.getItem("user")) 
        next(`/v2/home`);
      else {
        localStorage.clear();
        next();
      }
    },
  },

  /*DASHBOARD*/
  {
    path: "/home",
    component: DashStore,
    redirect: "/home/my_Courses",
    children: [
      {
        path: "/home/course/description",
        name: "Course",
        component: CourseDescription,
        meta: {
          autentiAuth: true,
        },
      },
      {
        path: "/home/my_Courses",
        name: "MyCourses",
        component: myCourses,
      },
      {
        path: "/home/course/in",
        name: "CourseIn",
        component: CourseIn,
      },
      {
        path: "/home/settings",
        name: "Settings",
        component: Settings,
      },
      {
        path: "/home/payment",
        name: "Payment",
        component: PaymentIni,
      },
      {
        path: "/home/payment/success",
        name: "PaymentSuccess",
        component: PaymentSuccess,
      },
      {
        path: "/home/payment/failure",
        name: "PaymentFailure",
        component: PaymentFailure,
      },
      {
        path: "/home/payment/pending",
        name: "PaymentPending",
        component: PaymentPending,
      },
    ],
    meta: {
      autentiAuth: true,
    },
    beforeEnter: (to, from, next) => {
      if (localStorage.getItem("user")) 
        next(`/v2/home`);
      else {
        localStorage.clear();
        next();
      }
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [...routes, ...routesv1],
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  let usuario = localStorage.getItem("a_t");

  let autorizacion = to.matched.some((record) => record.meta.autentiAuth);

  if (autorizacion && !usuario) next("/");
  else next();
  
});
export default router;